const caption_text = document.querySelectorAll(".caption .caption-copyright");
const observer = new ResizeObserver((entries) => {
  for (let entry of entries) {
    entry.target.classList[
      entry.target.scrollHeight > entry.contentRect.height ? "add" : "remove"
    ]("truncated");
  }
});

caption_text.forEach((caption_text) => {
  observer.observe(caption_text);
});
